import { ssmRouterGuardService } from "@/shared/services/router-guard-service";
import Vue from "vue";
import Router from "vue-router";
import { RouterNames } from "./routernames";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/tienda",
    },
    {
      path: "*",
      redirect: "/tienda",
    },
    {
      path: "/login",
      name: RouterNames.Login,
      component: () => import("@/views/login/login-formulario.vue"),
    },
    {
      path: "/lostpwd",
      name: RouterNames.lostpwd,
      component: () => import("@/views/lostpwdforms/pswlost.vue"),
    }, {
      path: "/escaner",
      name: RouterNames.escaner_sinautentificacion,
      component: () => import("@/views/escaner/EscanearProdcuto.vue"),

    }, {
      path: "/read/:code",
      name: RouterNames.read_qr_sin_login,
      component: () => import("@/views/vappers/read_qr.vue"),

    }, {
      path: "/verificacion/:token",
      name: RouterNames.verificacion,
      component: () => import("@/views/vappers/verify_token.vue"),

    }, {
      path: "/tienda",
      name: RouterNames.tienda,
      redirect: "/tienda/productos",
      component: () => import("@/views/TiendaOnline/home.vue"),
      children: [
        {
          path: "productos",
          name: RouterNames.tienda_productos,//productos.vue,
          meta: { mayorista: false },
          component: () => import("@/views/TiendaOnline/prodcutos-scroll-infinito.vue"),
        }, {
          path: "productos-mayorista",
          name: RouterNames.tienda_productos_mayorista,
          meta: { mayorista: true },
          component: () => import("@/views/TiendaOnline/prodcutos-scroll-infinito.vue"),
        }, {
          path: "producto/:id",
          name: RouterNames.tienda_producto,
          component: () => import("@/views/TiendaOnline/prodcuto-tienda-online.vue"),
        }, {
          path: "cesta",
          name: RouterNames.carrito_compra,//productos.vue
          component: () => import("@/views/TiendaOnline/carrito_compra.vue"),
        }, {
          path: "historial_carritos",
          name: RouterNames.historial_carritos,
          component: () => import("@/views/TiendaOnline/historial_carritos.vue"),
        },]
    },
    {
      path: "/confirm-new-password/:token",
      name: RouterNames.confirm_new_password,
      component: () => import("@/views/lostpwdforms/pwdlost-confirm.vue"),
    },
    {
      path: "/instalacion",
      name: RouterNames.instalacion,
      component: () => import("@/views/instalacion/instalacion.vue"),
    },
    {
      path: "/main",
      redirect: "/main/home",
      name: RouterNames.mainlayout,
      component: () => import("@/views/mainlayout/main-layout.vue"),
      beforeEnter: ssmRouterGuardService.beforeEnter,
      children: [
        {
          path: "home",
          name: RouterNames.Home,
          component: () => import("@/views/home/home.vue"),
        },
        {
          path: "tablas",
          name: RouterNames.tablas_test,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "tabla/:id",
              name: RouterNames.table,
              component: () =>
                import("@/views/dynamic_tables/full_dynamic_table.vue"),
            },
            {
              path: "dxtabla/:id",
              name: RouterNames.dxtable,
              component: () =>
                import("@/components/DataTableGenerico/DxFullDataTable.vue"),
            },
          ],
        }, {
          path: "formularios",
          name: RouterNames.formularios_dynamicos,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "formulario/:id/:id_objeto",
              name: RouterNames.formulario_dynamico,
              component: () =>
                import("@/views/createdynamicform/showdynamicform.vue"),
            },
          ],
        },
        {
          path: "tbkn",
          name: RouterNames.tbkn,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "tbkn/:id",
              name: RouterNames.viewtbkn,
              component: () =>
                import("@/views/dynamic_views/dynamic_change_views.vue"),
            },
          ],
        },
        {
          path: "kanban",
          name: RouterNames.kanban,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "kanban/:id",
              name: RouterNames.viewKanban,
              component: () => import("@/views/dynamickanban/ViewKanban.vue"),
            },
            {
              path: "fullkanban/:id",
              name: RouterNames.FullViewKanban,
              component: () => import("@/views/dynamickanban/ViewKanban.vue"),
            },
          ],
        },
        {
          path: "enumeraciones",
          name: RouterNames.enumeraciones,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "enumeracion/:id_cabezera",
              name: RouterNames.enumeracion,
              component: () =>
                import("@/views/prioridades/GenericPrioridadesForm.vue"),
            },
          ],
        }, {
          path: "productos",
          name: RouterNames.productos,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "stock",
              name: RouterNames.stock,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista/:id",
                  name: RouterNames.stocklista,
                  component: () => import("@/views/productos/DxTableProdcutos.vue"),
                  children: [],
                }, {
                  path: "historial-venta/:id",
                  name: RouterNames.stockhistorialventa,
                  component: () => import("@/views/productos/DxTableHistorialVenta.vue"),
                  children: [],
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.stockformulario,
                  component: () =>
                    import("@/views/usuarios/UsuariosFormulario.vue"),
                  children: [],
                }, {
                  path: "crear_nuevo/:id",
                  name: RouterNames.stockcrear_nuevo,
                  component: () =>
                    import("@/views/productos/NewProdcuto.vue"),
                  children: [],
                },
              ],
            }, {
              path: "reservas",
              name: RouterNames.reservas,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.reservaslista,
                  component: () => import("@/views/productos/ReservasProductos.vue"),
                  children: [],
                },
              ],
            }, {
              path: "devoluciones",
              name: RouterNames.devoluciones,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.devolucioneslista,
                  component: () => import("@/views/productos/devolucionesProdcuto.vue"),
                  children: [],
                },
              ],
            }, {
              path: "pdt",
              name: RouterNames.pdte,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.pdtelista,
                  component: () => import("@/views/productos/pendientedepago.vue"),
                  children: [],
                },
              ],
            }, {
              path: "producto",
              name: RouterNames.producto,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "ficha/:id",
                  name: RouterNames.fichaproducto,
                  component: () => import("@/views/productos/FichaProducto.vue"),
                  children: [],
                },
              ],
            }]
        }, {
          path: "escaner",
          name: RouterNames.escaner,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "escanear",
              name: RouterNames.escanear,
              component: () => import("@/views/escaner/EscanearProdcuto.vue"),
            }, {
              path: "lector",
              name: RouterNames.lector_codigos,
              component: () => import("@/views/escaner/LectorCodigos.vue"),
            }, {
              path: "receptor",
              name: RouterNames.receptor_codigos,
              component: () => import("@/views/escaner/ReceptorCodigos.vue"),
            }, {
              path: "escanear/:BarCode",
              name: RouterNames.escanearProducto,
              component: () => import("@/views/escaner/prodcuto-escaneado.vue"),
            }, {
              path: "escanear-fisico",
              name: RouterNames.escanearfisico,
              component: () => import("@/views/escaner/EscanearProductoFisico.vue"),
            },]
        }, {
          path: "cajas",
          name: RouterNames.cajas,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "stock",
              name: RouterNames.cajasstock,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.cajasstocklista,
                  component: () => import("@/views/cajas/cajasLista.vue"),
                }, {
                  path: "caja/:id/:caja",
                  name: RouterNames.cajasstockformulario,
                  component: () => import("@/views/productos/DxTableProdcutos.vue"),
                }, {
                  path: "imagenes",
                  name: RouterNames.cajasimagenes,
                  component: () => import("@/views/cajas/cajasImagenes.vue"),
                }]
            }]
        }, {
          path: "vappers",
          name: RouterNames.vappers,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "listado_qrs",
              name: RouterNames.listado_qrs,
              component: () => import("@/views/vappers/qrs_lista.vue"),
              children: [
              ]
            }]
        },
        {
          path: "administracion",
          name: RouterNames.administracion,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "usuarios",
              name: RouterNames.usuarios,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.usuarioslista,
                  component: () => import("@/views/usuarios/UsuariosLista.vue"),
                  children: [],
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.usuariosformulario,
                  component: () =>
                    import("@/views/usuarios/UsuariosFormulario.vue"),
                  children: [],
                },
              ],
            }, {
              path: "amazon",
              name: RouterNames.amazon,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "scraping",
                  name: RouterNames.amazonscraping,
                  component: () => import("@/components/titulopantalla/titulo.vue"),
                  children: [{
                    path: "productos",
                    name: RouterNames.amazonscrapingproductos,
                    component: () =>
                      import("@/views/administracion/ScrapingProductos.vue"),
                    children: [],
                  },],
                },

              ],
            }, {
              path: "carritos_compra",
              name: RouterNames.carritos_compra,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "carritos_compra_view",
                  name: RouterNames.carritos_compra_view,
                  component: () => import("@/views/carritos_compra/view_all_carritos_compra.vue"),
                  children: [],
                },

              ],
            }, {
              path: "importacion",
              name: RouterNames.importacion,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario",
                  name: RouterNames.importacionformulario,
                  component: () =>
                    import("@/views/importacion/formulario_importacion.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "grupos",
              name: RouterNames.grupos,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.gruposlista,
                  component: () => import("@/views/grupos/GruposLista.vue"),
                  children: [],
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.gruposformulario,
                  component: () =>
                    import("@/views/grupos/GruposFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "rol",
              name: RouterNames.rol,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.rollista,
                  component: () => import("@/views/roles/RolesLista.vue"),
                  children: [],
                },
                {
                  path: "formulario",
                  name: RouterNames.rolformulario,
                  component: () => import("@/views/roles/RolesFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "notificaciones/formulario",
              name: RouterNames.notificaciones,
              component: () =>
                import("@/views/notificaciones/NotificacionesForm.vue"),
            }, {
              path: "configuracion/formulario/:id",
              name: RouterNames.configuracion_clientes,
              component: () =>
                import("@/views/configuracion/formulario.vue"),
            },
          ],
        },
        {
          path: "plataforma",
          name: RouterNames.plataforma,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "instalacion/formulario",
              name: RouterNames.instalacion_plataforma,
              component: () => import("@/views/instalacion/instalacion.vue"),
            },
            {
              path: "menu",
              name: RouterNames.menu_plataforma,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.menu_plataforma_lista,
                  component: () =>
                    import("@/views/plataforma/menu/MenuLista.vue"),
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.menu_plataforma_formulario,
                  component: () =>
                    import("@/views/plataforma/menu/MenuFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "tester",
              name: "tester",
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
              ],
            },
            {
              path: "createdynamic",
              name: RouterNames.createdynamicmenu,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.createdynamicfromulario,
                  component: () =>
                    import("@/views/createdynamicform/createdynamicform.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "tablas",
              name: RouterNames.tablas,
              component: () =>
                import("@/components/titulopantalla/titulo-reactivo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.tablaslista,
                  component: () =>
                    import(
                      "@/views/dynamic_tables/views_settings/dynamic_tables_lista.vue"
                    ),
                  children: [],
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.tablasformulario,
                  component: () =>
                    import(
                      "@/views/dynamic_tables/views_settings/dynamic_tables_formulario.vue"
                    ),
                  children: [],
                },
              ],
            },
            {
              path: "clientes",
              name: RouterNames.clientes,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.clientesformulario,
                  component: () =>
                    import(
                      "@/views/plataforma/clientes/ClientesFormulario.vue"
                    ),
                  children: [],
                },
              ],
            },
          ],
        },
        {
          path: "mi_perfil",
          name: RouterNames.mi_perfil,
          component: () => import("@/views/usuarios/MiPerfil.vue"),
        },
        {
          path: "cerrar_session",
          name: RouterNames.cerrar_session,
          component: () => import("@/views/cerrar_session.vue"),
          children: [],
        },
      ],
    },
  ],
});
